export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      contact: "Contact",
    },
    hero: {
      overline: "Independent Architect — Spain",
      headline: "Architectural Projects and Services",
      subtitle:
        "Practical architectural solutions for homes, renovations, technical documentation and new projects. Clear guidance from the first idea to the final approval.",
      ctaPrimary: "Request Consultation",
      ctaSecondary: "View Services",
    },
    services: {
      overline: "What I do",
      title: "Services",
      subtitle:
        "A focused set of architectural and technical services for individuals, businesses and property owners.",
      items: [
        {
          title: "Rehabilitation & Interior Renovation Projects",
          desc: "End-to-end design and management of rehabilitation and interior remodeling projects for homes, premises and buildings — optimizing functionality, comfort and property value.",
        },
        {
          title: "Commercial-to-Residential Conversions",
          desc: "Feasibility studies and full processing to convert commercial premises into homes, ensuring compliance with urban planning and habitability regulations.",
        },
        {
          title: "Dwelling Segregation & Aggregation",
          desc: "Technical and administrative management to divide or merge dwellings, adapting spaces to new needs and legal requirements.",
        },
        {
          title: "Land Reparcellation",
          desc: "Drafting and processing of reparcellation projects for the legal and urban reorganization of plots and parcels.",
        },
        {
          title: "Accessibility & Energy Retrofit Studies",
          desc: "Analysis and improvement proposals to remove architectural barriers, reduce energy consumption and enhance building comfort.",
        },
        {
          title: "Activity Licenses",
          desc: "Advice and processing of licenses for the opening, modification or legalization of commercial and service activities.",
        },
        {
          title: "Occupancy Certificates",
          desc: "Management of first and second occupancy certificates, verifying compliance with the conditions required for residential use.",
        },
        {
          title: "Energy Performance Certificates",
          desc: "Issuing of energy certificates for homes, new buildings, premises and energy renovation works.",
        },
        {
          title: "Descriptive Certificates with Georeferenced Coordinates",
          desc: "Preparation of descriptive and graphic certificates with georeferenced coordinates for land registry, cadastral and property regularization procedures.",
        },
      ],
    },
    about: {
      overline: "Profile",
      title: "About Oriol",
      paragraphs: [
        "I am a qualified architect from the Escola Tècnica Superior d'Arquitectura del Vallès (ETSAV) at the Universitat Politècnica de Catalunya (UPC), graduated in 2015. I complement my training with specializations as a technical drafter of self-protection plans, senior technician in occupational risk prevention and Health & Safety consultancy.",
        "Throughout my professional career I have built broad experience in building rehabilitation projects, technical certifications and processing of activity licenses, offering a rigorous, close and tailored service adapted to the needs of each client.",
      ],
      highlights: [
        "Clear communication",
        "Technical expertise",
        "Practical solutions",
        "Personalized service",
      ],
    },
    contact: {
      overline: "Get in touch",
      title: "Let's Talk",
      subtitle: "Tell me what you need and I will get back to you.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      send: "Send Message",
      sending: "Sending…",
      success: "Thank you. Your message has been sent — I'll be in touch shortly.",
      error: "Sorry, something went wrong. Please try again or write directly to the email below.",
      rateLimit: "Too many messages sent from this connection. Please try again in a few minutes.",
      info: {
        role: "Architect",
        emailLabel: "Email",
        phoneLabel: "Phone",
        locationLabel: "Location",
        location: "Spain",
      },
    },
    footer: {
      role: "Architect",
      tagline: "Architectural projects and services without complications.",
      rights: "All rights reserved.",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      about: "Sobre Oriol",
      contact: "Contacto",
    },
    hero: {
      overline: "Arquitecto Independiente — España",
      headline: "Proyectos y servicios arquitectónicos",
      subtitle:
        "Soluciones arquitectónicas prácticas para viviendas, reformas, documentación técnica y nuevos proyectos. Acompañamiento claro desde la primera idea hasta la aprobación final.",
      ctaPrimary: "Solicitar consulta",
      ctaSecondary: "Ver servicios",
    },
    services: {
      overline: "Qué hago",
      title: "Servicios",
      subtitle:
        "Un conjunto enfocado de servicios arquitectónicos y técnicos para particulares, empresas y propietarios.",
      items: [
        {
          title: "Proyectos de Rehabilitación y Reformas Interiores",
          desc: "Diseño y gestión integral de proyectos de rehabilitación y reforma para viviendas, locales y edificios, optimizando funcionalidad, confort y valor del inmueble.",
        },
        {
          title: "Cambios de Uso de Local a Vivienda",
          desc: "Estudio de viabilidad y tramitación completa para transformar locales en viviendas, garantizando el cumplimiento de la normativa urbanística y de habitabilidad.",
        },
        {
          title: "Segregaciones y Agregaciones de Viviendas",
          desc: "Gestión técnica y administrativa para dividir o unir viviendas, adaptando los espacios a nuevas necesidades y requisitos legales.",
        },
        {
          title: "Reparcelaciones",
          desc: "Redacción y tramitación de proyectos de reparcelación para la reorganización y adecuación jurídica y urbanística de fincas y parcelas.",
        },
        {
          title: "Estudios de Accesibilidad y Rehabilitación Energética",
          desc: "Análisis y propuestas de mejora para eliminar barreras arquitectónicas, reducir consumos energéticos y mejorar el confort de los edificios.",
        },
        {
          title: "Licencias de Actividad",
          desc: "Asesoramiento y tramitación de licencias para la apertura, modificación o legalización de actividades comerciales y de servicios.",
        },
        {
          title: "Cédulas de Habitabilidad",
          desc: "Gestión de cédulas de primera y segunda ocupación, verificando el cumplimiento de las condiciones exigidas para el uso residencial.",
        },
        {
          title: "Certificados Energéticos",
          desc: "Emisión de certificados energéticos para viviendas, edificios de nueva construcción, locales y actuaciones de rehabilitación energética.",
        },
        {
          title: "Certificados Descriptivos con Coordenadas Georreferenciadas",
          desc: "Elaboración de certificados descriptivos y gráficos con coordenadas georreferenciadas para trámites registrales, catastrales y de regularización de fincas.",
        },
      ],
    },
    about: {
      overline: "Perfil",
      title: "Sobre Oriol",
      paragraphs: [
        "Soy arquitecto titulado por la Escola Tècnica Superior d'Arquitectura del Vallès (ETSAV) de la Universitat Politècnica de Catalunya (UPC) desde 2015. Complemento mi formación con las especializaciones de técnico redactor de planes de autoprotección, técnico superior en prevención de riesgos profesionales y consultoría de Seguridad y Salud.",
        "A lo largo de mi trayectoria profesional he desarrollado una amplia experiencia en proyectos de rehabilitación de edificios, certificaciones técnicas y tramitación de licencias de actividad, ofreciendo un servicio riguroso, cercano y adaptado a las necesidades de cada cliente.",
      ],
      highlights: [
        "Comunicación clara",
        "Conocimiento técnico",
        "Soluciones prácticas",
        "Atención personalizada",
      ],
    },
    contact: {
      overline: "Contacto",
      title: "Hablemos",
      subtitle: "Cuéntame qué necesitas y me pondré en contacto contigo.",
      name: "Nombre",
      email: "Email",
      phone: "Teléfono",
      message: "Mensaje",
      send: "Enviar mensaje",
      sending: "Enviando…",
      success: "Gracias. Tu mensaje se ha enviado — me pondré en contacto en breve.",
      error: "Lo siento, algo ha fallado. Inténtalo de nuevo o escríbeme directamente al email de abajo.",
      rateLimit: "Demasiados mensajes desde esta conexión. Inténtalo de nuevo en unos minutos.",
      info: {
        role: "Arquitecto",
        emailLabel: "Email",
        phoneLabel: "Teléfono",
        locationLabel: "Ubicación",
        location: "España",
      },
    },
    footer: {
      role: "Arquitecto",
      tagline: "Proyectos y servicios arquitectónicos sin complicaciones.",
      rights: "Todos los derechos reservados.",
    },
  },
};

export const CONTACT = {
  email: "architectorial.studio@gmail.com",
  phone: "+34 697 212 348",
  phoneHref: "tel:+34697212348",
  emailHref: "mailto:architectorial.studio@gmail.com",
};
